import { useContext } from 'react';
import { ConfirmContext } from './ConfirmContext';
import { SettingsMenuContext } from './SettingsMenuContext';

export const useConfirm = () => useContext(ConfirmContext);
export const useSettingsMenu = () => useContext(SettingsMenuContext);
